export interface SkillItem {
    text: string;
}

export const skills: SkillItem[] = [
    { text: "Kotlin + jetpack compose" },
    { text: "Java" },
    { text: "C/C++" },
    { text: "Java Spring" },
    { text: "Typescript + React" },
    { text: "Linux" },
    { text: "python" },
    { text: "PyTorch" },
    { text: "Jax" },
    { text: "bash" },
];
